import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class CustomersAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

// ******************************
//        Public methods
// ******************************

  // CREATE //
  createSuccess() {
    const message = {
      body: 'CUSTOMER_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message, null, null)
  }

  createError() {
    const message = {
      body: 'CUSTOMER_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'CUSTOMER_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'CUSTOMER_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteOneSuccess(customer) {
    const message = {
      body: 'X_CUSTOMER_DELETE_ONE_SUCCESS'
    };
    let name;
    if (customer) {
      name = (customer.firstName && customer.lastName) ? `${customer.firstName} ${customer.lastName}` : customer.businessName;
    }
    return this.bringozToastService.success(message, {name: name})
  }

  deleteOneError() {
    const message = {
      body: 'CUSTOMER_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD ADDRESS //
  addAddressSuccess(delay?) {
    const message = {
      body: 'CUSTOMER_ADD_ADDRESS_SUCCESS'
    };
    return this.bringozToastService.success(message, null, null, delay)
  }

  addAddressError() {
    const message = {
      body: 'CUSTOMER_ADD_ADDRESS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE ADDRESS //
  updateAddressSuccess(address) {
    const message = {
      body: 'X_CUSTOMER_UPDATE_ADDRESS_SUCCESS'
    };
    return this.bringozToastService.success(message, address)
  }

  updateAddressError() {
    const message = {
      body: 'CUSTOMER_UPDATE_ADDRESS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE DEFAULT ADDRESS //
  updateDefaultAddressSuccess(delay?) {
    const message = {
      body: 'CUSTOMER_UPDATE_DEFAULT_ADDRESS_SUCCESS'
    };
    return this.bringozToastService.success(message, null, null, delay)
  }

  updateDefaultAddressError() {
    const message = {
      body: 'CUSTOMER_UPDATE_DEFAULT_ADDRESS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateDefaultAddressInfo() {
    const message = {
      body: 'CUSTOMER_UPDATE_DEFAULT_ADDRESS_INFO'
    };
    return this.bringozToastService.info(message)
  }

  // DELETE ADDRESS //
  deleteAddressSuccess(address) {
    const message = {
      body: 'X_CUSTOMER_DELETE_ADDRESS_SUCCESS'
    };
    return this.bringozToastService.success(message, address)
  }

  deleteAddressError() {
    const message = {
      body: 'CUSTOMER_DELETE_ADDRESS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  exportSuccess() {
    const message = {
      body: 'CUSTOMERS_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'CUSTOMERS_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.customers')
  .service('customersAlerts', CustomersAlerts);
